import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { CheckBoxTable, SortDataColumn } from "../../models/table.model";
import { SortTableService } from "../../services/sort-table.service";
import { CheckboxTableService } from "../../services/checkbox-table.service";
import { TableHeightService } from "../../services/table-height.service";
import { Subscription, debounceTime } from "rxjs";
import { VirtualCashDataService } from "./services/virtual-cash-data.service";
import { FilterModelDto } from "../../models/filter.model";
import { GroupDataDto, GroupDeleteDataDto, PercentDataPosDto, VirtualCashModelsDto } from "./models/virtual-cash.models";
import { ModalService } from "../../services/modal.service";
import { NotificationService } from "../../services/notification.service";
import { FormSelectModelDto } from "../payment-link-list/models/paylinks.model";
import { FilterSettingService } from "src/app/services/filter-setting.service";
import { Router } from "@angular/router";
import { ContextMenuService } from "src/app/services/context-menu.service";
import { PermissionService } from "src/app/services/permission.service";

@Component({
	selector: "app-virtual-cash-list",
	templateUrl: "./virtual-cash-list.component.html",
	styleUrls: ["./virtual-cash-list.component.scss"],
})
export class VirtualCashListComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild("tableBlock") tableBlock: ElementRef | undefined;
	@ViewChild("tableBody") tableBody: ElementRef | undefined;
	@ViewChild("contentBlock") contentBlock: ElementRef | undefined;

	filterStatuses: FilterModelDto[] | undefined;
	filterP2p: FilterModelDto[] | undefined;
	filterCurrency: FilterModelDto[] | undefined;
	filterAdditional: FilterModelDto[] | undefined;

	delta = 150;
	lastPage = false;
	currentPage = 0;

	isOpenModalEditVirtualCash = false;
	isOpenModalCommissionVirtualCash = false;
	isOpenModalDeleteVirtualCash = false;
	isOpenModalDeleteGroupVirtualCash = false;
	isOpenModalToggleVirtualCash = false;
	isOpenModalGroupToggleVirtualCash = false;

	isOpenFilter = false;

	selectedRow: any[] = [];

	virtualPosList: VirtualCashModelsDto[] = [];
	selectedVirtualPos: VirtualCashModelsDto | null = null;
	selectedVirtualPosId: number | null = null;
	sortColumnData: SortDataColumn | undefined;

	groupStatus: string | "blocked" | "unlocked" | "none" = "none";

	percentData: PercentDataPosDto[] = [];

	subs: Subscription[] = [];

	deleteId!: number;

	savedCardListList: FormSelectModelDto[] = [];
	currenciesList: FormSelectModelDto[] = [];

	filterData: any;
	searchWord: string | undefined = "";

	constructor(
		private sortTableService: SortTableService,
		private checkboxTableService: CheckboxTableService,
		private tableHeightService: TableHeightService,
		private renderer: Renderer2,
		private virtualCashDataService: VirtualCashDataService,
		private modalService: ModalService,
		private notificationService: NotificationService,
		private filterSettingService: FilterSettingService,
		private router: Router,
		public contextMenuService: ContextMenuService,
		private permissionService: PermissionService
	) {}

	ngOnInit() {
		this.initFilter();
		this.initModal();
		this.initCheckboxSelectAll();

		this.sortColumn("VIRTUAL_POS_NAME");
	}

	ngAfterViewInit() {
		this.subs.push(
			this.tableHeightService.tableHeight$.subscribe({
				next: (res) => {
					this.renderer.setStyle(this.tableBlock?.nativeElement, "height", res);
				},
			})
		);
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	initModal() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => {
					if (!res) {
						this.isOpenModalEditVirtualCash = false;
						this.isOpenModalCommissionVirtualCash = false;
						this.isOpenModalDeleteVirtualCash = false;
						this.isOpenModalDeleteGroupVirtualCash = false;
						this.isOpenModalToggleVirtualCash = false;
						this.isOpenModalGroupToggleVirtualCash = false;
					}
				},
			})
		);
	}

	toggleFilter(filterState: boolean) {
		this.isOpenFilter = filterState;
	}

	onScroll(event: any): void {
		const tableBodyHeight = this.tableBody?.nativeElement.clientHeight;
		const tableBlockHeight = this.tableBlock?.nativeElement.clientHeight;
		const scrollTable = event.target.scrollTop;
		if (tableBodyHeight - tableBlockHeight - scrollTable < this.delta && !this.lastPage) {
			this.loadVirtualCashList();
		}
	}

	@HostListener("document:scroll", ["$event"])
	onWindowScroll(event: any): void {
		if (window.innerWidth <= 768) {
			if (this.contentBlock?.nativeElement.clientHeight - window.scrollY - window.innerHeight + 120 < this.delta && !this.lastPage) {
				this.loadVirtualCashList();
			}
		}
	}

	loadVirtualCashList() {
		this.lastPage = true;
		this.virtualCashDataService.loadVirtualCashList(this.currentPage, this.searchWord, this.filterData).subscribe({
			next: (res) => {
				this.virtualPosList.push(...res.content);
				this.currentPage++;
				this.lastPage = res.last;
			},
		});
	}

	initFilter() {
		this.virtualCashDataService.loadVirtualCashFilter().subscribe({
			next: (res) => {
				this.filterAdditional = res["additional_params"];
				this.filterStatuses = res["statuses"];
				this.filterP2p = res["p2p"];
				this.filterCurrency = res["currency"];
				this.filterCurrency?.forEach((item) => {
					this.currenciesList.push({
						fieldName: item.fieldName,
						value: item.value,
						description: item.description,
					});
				});
			},
		});

		this.subs.push(
			this.filterSettingService.filterSetData$.subscribe({
				next: (res) => {
					this.filterData = res;
					this.currentPage = 0;

					this.virtualPosList = [];
					this.loadVirtualCashList();
					this.selectedRow = [];
					this.checkboxTableService.compareCount$.next();
				},
			})
		);

		this.subs.push(
			this.filterSettingService.inputSearch$.pipe(debounceTime(300)).subscribe({
				next: (res) => {
					this.virtualCashDataService.loadSearchList(res).subscribe({
						next: (res) => {
							this.filterSettingService.responseSearchData$.next(res.content);
						},
					});
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterSearchWord$.subscribe({
				next: (res) => {
					this.searchWord = res;
				},
			})
		);

		this.subs.push(
			this.filterSettingService.filterAllReset$.subscribe({
				next: () => {
					this.searchWord = "";
					this.filterData = undefined;
					this.currentPage = 0;

					this.virtualPosList = [];
					this.loadVirtualCashList();
					this.selectedRow = [];
					this.checkboxTableService.compareCount$.next();
				},
			})
		);
	}

	initCheckboxSelectAll() {
		this.subs.push(
			this.checkboxTableService.checkboxSelectAll$.subscribe({
				next: (res) => {
					this.selectedRow = [];
					if (res) {
						this.virtualPosList.forEach((item) => this.selectedRow.push(item.id));
					}
					this.setStatusGroup();
				},
			})
		);
	}

	sortColumn(column: string) {
		this.sortColumnData = this.sortTableService.sort(column);

		const sort = `order=${this.sortColumnData?.order}&field=${this.sortColumnData?.field}`;
		this.sortTableService.sortColum$.next(sort);

		this.currentPage = 0;
		this.virtualPosList = [];
		this.loadVirtualCashList();
	}

	checkChange(item: CheckBoxTable) {
		if (item.state) {
			this.setCheckboxState(item);
		} else {
			this.clearCheckboxState(item);
		}
		this.checkboxTableService.compareCount$.next();
		this.setStatusGroup();
	}

	setCheckboxState(item: CheckBoxTable) {
		this.selectedRow.push(item.id);
		this.setStatusGroup();
	}

	clearCheckboxState(item: CheckBoxTable) {
		for (let i = 0; i < this.selectedRow.length; i++) {
			if (item.id === this.selectedRow[i]) {
				this.selectedRow.splice(i, 1);
				return;
			}
		}
	}

	setStatusGroup() {
		let blocked = 0;
		let unlocked = 0;
		if (this.selectedRow.length > 0) {
			for (let i = 0; i < this.virtualPosList.length; i++) {
				if (this.selectedRow.includes(this.virtualPosList[i].id)) {
					if (this.virtualPosList[i].is_blocked) {
						blocked++;
					} else {
						unlocked++;
					}
				}
			}
		}

		if ((blocked !== 0 && unlocked !== 0) || (blocked === 0 && unlocked === 0)) {
			this.groupStatus = "none";
		} else {
			if (blocked !== 0 && unlocked === 0) {
				this.groupStatus = "blocked";
			} else {
				this.groupStatus = "unlocked";
			}
		}
	}

	toggleGroupBlock() {
		this.isOpenModalGroupToggleVirtualCash = true;
	}

	toggleBlock(virtualPos: VirtualCashModelsDto) {
		if (this.permissionService.hasPermission(["VIRTUAL_POS_BLOCK"])) {
			this.isOpenModalToggleVirtualCash = true;
			this.selectedVirtualPos = virtualPos;
		} else {
			this.notificationService.setConfiguration(
				"icon-1",
				"warning",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_ERROR",
				"ROLE_PAGE.NOTIFICATION.PERMISSION_DESCRIPTION_1"
			);
			this.notificationService.showNotification();
		}
	}

	unlocked(id: number) {
		this.virtualCashDataService.changeStatus(id, false).subscribe({
			next: () => {
				this.notificationService.setConfiguration(
					"icon-2",
					"warning",
					"VIRTUAL_POS_PAGE.NOTIFICATION.UNLOCKED_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				this.selectedVirtualPos = null;
				this.changeStatus(id);
			},
		});
	}

	blocked(id: number) {
		this.virtualCashDataService.changeStatus(id, true).subscribe({
			next: () => {
				this.notificationService.setConfiguration(
					"icon-1",
					"warning",
					"VIRTUAL_POS_PAGE.NOTIFICATION.BLOCKED_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				this.selectedVirtualPos = null;
				this.changeStatus(id);
			},
		});
	}

	groupBlocked() {
		const data: GroupDataDto = {
			idList: this.selectedRow,
		};
		this.virtualCashDataService.groupBlockedCash(data).subscribe({
			next: () => {
				this.notificationService.setConfiguration(
					"icon-1",
					"warning",
					"VIRTUAL_POS_PAGE.NOTIFICATION.BLOCKED_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				this.selectedRow.forEach((item) => {
					this.updateChangedPos(item);
				});
			},
		});
	}

	groupUnlocked() {
		const data: GroupDataDto = {
			idList: this.selectedRow,
		};
		this.virtualCashDataService.groupUnlockedCash(data).subscribe({
			next: () => {
				this.notificationService.setConfiguration(
					"icon-2",
					"warning",
					"VIRTUAL_POS_PAGE.NOTIFICATION.UNLOCKED_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.selectedRow.forEach((item) => {
					this.updateChangedPos(item);
				});
			},
		});
	}

	changeStatus(id: number) {
		for (let i = 0; i < this.virtualPosList.length; i++) {
			if (this.virtualPosList[i].id === id) {
				this.virtualPosList[i].is_blocked = !this.virtualPosList[i].is_blocked;
				return;
			}
		}
	}

	delete(id: number) {
		this.deleteId = id;
		this.isOpenModalDeleteVirtualCash = true;
	}

	edit(id: number) {
		this.selectedVirtualPosId = id;
		this.isOpenModalEditVirtualCash = true;
	}

	commission(id: number) {
		this.percentData = [];
		this.virtualCashDataService.loadCommissionData(id).subscribe({
			next: (res) => {
				this.percentData = res;
				this.isOpenModalCommissionVirtualCash = true;
			},
		});
	}

	deleteVirtualCash(id: number) {
		this.virtualCashDataService.deleteVirtualCash(id).subscribe({
			next: () => {
				this.notificationService.setConfiguration(
					"icon-6",
					"error",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DELETE_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				this.modalService.closeModal();
				for (let i = 0; i < this.virtualPosList.length; i++) {
					if (this.virtualPosList[i].id === id) {
						this.virtualPosList.splice(i, 1);
					}
				}
			},
		});
	}

	updateChangedPos(id: number) {
		this.virtualCashDataService.loadDetailVirtualCash(id).subscribe({
			next: (res) => {
				this.notificationService.setConfiguration(
					"icon-2",
					"warning",
					"VIRTUAL_POS_PAGE.NOTIFICATION.EDIT_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				for (let i = 0; i < this.virtualPosList.length; i++) {
					if (this.virtualPosList[i].id === id) {
						this.virtualPosList[i] = res;
						this.selectedRow = [];
						return;
					}
				}
			},
		});
	}

	editedVirtualPos() {
		this.currentPage = 0;
		this.virtualPosList = [];
		this.loadVirtualCashList();
		this.selectedRow = [];
		this.checkboxTableService.compareCount$.next();

		this.notificationService.setConfiguration(
			"icon-2",
			"warning",
			"VIRTUAL_POS_PAGE.NOTIFICATION.EDIT_TITLE",
			"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
		);
		this.notificationService.showNotification();
	}

	deleteGroup() {
		this.isOpenModalDeleteGroupVirtualCash = true;
	}

	deleteGroupVirtualCash() {
		const data: GroupDeleteDataDto = {
			vpIdList: this.selectedRow,
		};
		this.virtualCashDataService.groupDeleteCash(data).subscribe({
			next: () => {
				this.notificationService.setConfiguration(
					"icon-6",
					"error",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DELETE_TITLE",
					"VIRTUAL_POS_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				this.modalService.closeModal();
				this.selectedRow.forEach((item) => {
					for (let i = 0; i < this.virtualPosList.length; i++) {
						if (this.virtualPosList[i].id === item) {
							this.virtualPosList.splice(i, 1);
						}
					}
				});
				this.selectedRow = [];
			},
		});
	}

	openTerminalList(id: number) {
		this.router.navigate(["/terminal-list"], {
			queryParams: {
				virtual_pos_id: id,
			},
		});
	}
}
